import api, { DeleteWelcomeMessageSetResult, WelcomeMessageSetDto } from '@/service/api';
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';

@Module({
    name: 'welcomeMessageSets',
})
export default class WelcomeMessageSetsModule extends VuexModule {
    public list: WelcomeMessageSetDto[] = [];
    public loading = false;
    public loaded = false;

    @Mutation
    public setMessagesList(list: WelcomeMessageSetDto[]) {
        this.list = list;
    }

    @Mutation
    public upsertSet(item: WelcomeMessageSetDto) {
        const idx = this.list.findIndex((set) => set.id === item.id);
        if (idx === -1) {
            this.list = [...this.list, item];
            return;
        }

        const next = [...this.list];
        next.splice(idx, 1, item);
        this.list = next;
    }

    @Mutation
    public removeSet(id: string) {
        this.list = this.list.filter((set) => set.id !== id);
    }

    @Mutation
    public setLoading(v: boolean) {
        this.loading = v;
    }

    @Mutation
    public setLoaded(v: boolean) {
        this.loaded = v;
    }

    @Mutation
    public resetState() {
        this.list = [];
        this.loading = false;
        this.loaded = false;
    }

    @Action({ rawError: true })
    public async fetchWelcomeMessageSets(force = false) {
        if (this.loaded && !force) {
            return this.list;
        }

        this.setLoading(true);
        try {
            const list = await api.listWelcomeMessageSets();
            this.setMessagesList(list);
            this.setLoaded(true);
            return list;
        } finally {
            this.setLoading(false);
        }
    }

    @Action({ rawError: true })
    public async createWelcomeMessageSet(payload: { title: string; welcomeMessage: string; purchaseMessage: string }) {
        const created = await api.addWelcomeMessageSet(payload);
        this.upsertSet(created);
        this.setLoaded(true);
        return created;
    }

    @Action({ rawError: true })
    public async updateWelcomeMessageSet(
        { id, payload }: { id: string; payload: { title: string; welcomeMessage: string; purchaseMessage: string } },
    ) {
        const updated = await api.updateWelcomeMessageSet(id, payload);
        this.upsertSet(updated);
        this.setLoaded(true);
        return updated;
    }

    @Action({ rawError: true })
    public async deleteWelcomeMessageSet(id: string) {
        const result: DeleteWelcomeMessageSetResult = await api.deleteWelcomeMessageSet(id);
        this.removeSet(id);
        return result;
    }

    @Action({ rawError: true })
    public async assignWelcomeMessageSet(
        { sessionId, welcomeMessageSetId }: { sessionId: string; welcomeMessageSetId: string | null },
    ) {
        await api.assignWelcomeMessageSet(sessionId, welcomeMessageSetId);
    }

    @Action({ rawError: true })
    public resetWelcomeMessageSets() {
        this.resetState();
    }

    get welcomeMessageSetList() {
        return this.list;
    }
}
